import instantsearch from 'instantsearch.js';
import { configure, stats, menu, clearRefinements, hits } from 'instantsearch.js/es/widgets';
import { history } from 'instantsearch.js/es/lib/routers';
import { customPagination } from '@pratt/js/components/algolia/pagination';
import searchClient from '@pratt/js/components/algolia/search-client';
import { HitHelpers } from '@pratt/js/components/algolia/hit-helpers';

class TagSearch {
  constructor(rootEl) {
    this.rootEl = rootEl;
    if (!this.rootEl) {
      throw new Error('Root tag search element not found.');
    }

    this.hitsPerPage = 24;
    this.tag = this.rootEl.dataset['tag'];

    this.search = instantsearch({
      indexName: this.rootEl.dataset['algoliaIndex'],
      searchClient: searchClient,
      routing: {
        router: history({
          cleanUrlOnDispose: true,
        }),
      },
      future: {
        preserveSharedStateOnUnmount: true,
      },
    });

    this.init();
    this.search.start();
  }

  init() {
    this.search.addWidgets([
      // https://www.algolia.com/doc/api-reference/widgets/configure/js/
      // Parameter options: https://www.algolia.com/doc/api-reference/search-api-parameters/
      configure({
        hitsPerPage: this.hitsPerPage,
        distinct: true,
        // Force faceting to be applied after de-duplication (via the Distinct setting)
        facetingAfterDistinct: true,
        // Filter results by 'tags' facet
        // https://www.algolia.com/doc/api-reference/api-parameters/filters/#facet-filters
        filters: `tags:"${this.tag}"`,
      }),

      // https://www.algolia.com/doc/api-reference/widgets/stats/js/
      stats({
        container: '.js-tag-search-count',
        templates: {
          text: `<span aria-label="{{ nbHits }} tagged items">{{ nbHits }}</span>`,
        },
      }),

      // https://www.algolia.com/doc/api-reference/widgets/clear-refinements/js/
      clearRefinements({
        container: '.js-tag-search-clear',
        templates: {
          resetLabel: 'All',
        },
      }),

      // https://www.algolia.com/doc/api-reference/widgets/menu/js/
      menu({
        container: '.js-tag-search-menu',
        attribute: 'type',
        sortBy: ['name:asc'],
        templates: {
          item(hit) {
            return `
              <a class="${hit.cssClasses.link}" href="${hit.url}">
                <span class="${hit.cssClasses.label}">${HitHelpers.getTypeDisplay(hit.label)}</span>
              </a>
            `;
          },
        },
      }),

      // https://www.algolia.com/doc/api-reference/widgets/hits/js/
      hits({
        container: '.js-tag-search-hits',
        templates: {
          /* eslint-disable */
          item(hit) {
            return `
              <article class="tag-hit" data-last-modified="${hit.last_modified}">
                <a class="tag-hit__link" href="${hit.url}">
                  <div class="tag-hit__title">
                    <span class="tag-hit__title-text">${hit.title}</span>
                  </div>
                  <div class="tag-hit__type">${HitHelpers.getTypeDisplay(hit.type)}</div>
                  <div class="tag-hit__school">
                    ${hit.schools?.length ? hit.schools.join(', ') : ''}
                  </div>
                  <div class="tag-hit__thumbnail">
                    ${hit.thumbnail ? `<img src="${hit.thumbnail}" alt="${hit.title}" />` : ''}
                  </div>
                </a>
              </article>
            `;
          },
          /* eslint-enable */
        },
      }),

      // https://www.algolia.com/doc/api-reference/widgets/pagination/js/
      customPagination({
        container: document.querySelector('.js-tag-search-pagination'),
      }),
    ]);
  }
}

export default TagSearch;
